'use strict'

module.exports = root

var u = require('unist-builder')
var wrap = require('../wrap')
var all = require('../all')

/* Transform a `root`. */
function root(h, node) {
  return h.augment(node, u('root', wrap(all(h, node))))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/root.js
// module id = 902
// module chunks = 95715928098905 168707334958949